import FormItemLabel from "antd/lib/form/FormItemLabel";
import React, { FC, useState, useEffect } from "react";

import participantPropType from "../../propTypes/participant";
import Track from "../Track/Track";

// import styles from "./Participant.module.scss";

const Participant: FC<{
  participant?: any;
  className?: string;
  isRemote?: boolean;
}> = ({ participant, className, isRemote }) => {

  const [selected, setSelected] = useState<any>();
  const [participantTracks, setParticipantTracks] = useState<any>([]);
  
  // useEffect(() => {
  //   return () => {
  //     const length = Array.from(participant.tracks.values())?.length;
  //     console.log('track length', length)
  //     if(length === 1){
  //       setSelected(0);
  //     }
  //   };
  // }, [Array.from(participant.tracks.values()).length]);

  return (
    <div className={className ? `${className}` : "wrapper"}>
      {/* { isRemote && <label className="label-participant">{participant.identity}</label> } */}
      {Array.from(participant.tracks.values())?.map(
        (trackPublication: any, idx) =>
          trackPublication.track && (
            <Track
              isRemote={isRemote}
              key={trackPublication.track.name}
              track={trackPublication.track}
              selected={selected}
              onClick={() => {
                setSelected(idx)
              }}
            />
          )
      )}
    </div>
  );
};

Participant.propTypes = {
  participant: participantPropType.isRequired,
};

export default Participant;
